var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"award-card reveal-bottom"},[_c('div',{staticClass:"card-img-box"},[_c('img',{staticClass:"card-img",attrs:{"src":_vm.img,"alt":"img"}})]),_vm._v(" "),_c('p',{staticClass:"card-p"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b22d7c5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Awards/Card.vue
// module id = null
// module chunks = 